import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import * as sectionsActions from "../sections/actions";
import * as pagesTranslationsActions from "../pageTranslations/actions";
import * as pagesListsActions from "../pagesLists/actions";
import { Record, Map, fromJS } from "immutable";
import { isApiCall } from "../app/schema";

import Forms from "./forms";
import Galleries from "./galleries";

const feature = "galleries";

const START = "_START";
const SUCCESS = "_SUCCESS";
const ERROR = "_ERROR";

const InitialState = Record({
  forms: new Forms(),
  galleries: new Galleries()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function GalleriesReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
      action.payload.entities &&
      action.payload.entities.galleries
    ) {
      state = state.updateIn(["galleries", "entities"], map =>
        map.mergeDeep(action.payload.entities.galleries)
      );
    }
  }

  switch (action.type) {
    case actions.PATCH_GALLERY + START: {
      return state.setIn(["galleries", "loading"], true);
    }
    case actions.PATCH_GALLERY + SUCCESS: {
      return state.setIn(["galleries", "loading"], false);
    }
    case actions.PATCH_GALLERY + ERROR: {
      return state.setIn(["galleries", "loading"], false);
    }

    case actions.DELETE_GALLERY + START: {
      return state.deleteIn(["galleries", "entities", action.payload.uid]);
    }

    case actions.GET_GALLERY_GALLERY_ITEMS + START: {
      return state.setIn(["galleries", "loading"], true);
    }
    case actions.GET_GALLERY_GALLERY_ITEMS + SUCCESS: {
      if (state.getIn(["galleries", "entities", action.meta.uid, "items"])) {
        state = state.updateIn(
          ["galleries", "entities", action.meta.uid, "items"],
          map => map.mergeDeep(action.payload.entities.galleryItems)
        );
      } else {
        state = state.setIn(
          ["galleries", "entities", action.meta.uid, "items"],
          fromJS(action.payload.entities.galleryItems)
        );
      }

      return state.setIn(["galleries", "loading"], false);
    }
    case actions.GET_GALLERY_GALLERY_ITEMS + ERROR: {
      return state.setIn(["galleries", "loading"], false);
    }

    case actions.POST_GALLERY_GALLERY_ITEMS + START: {
      return disableForm(state, "createGalleryGalleryItem");
    }
    case actions.POST_GALLERY_GALLERY_ITEMS + SUCCESS: {
      state = clearForm(state, "createGalleryGalleryItem", Forms);
      return enableForm(state, "createGalleryGalleryItem");
    }
    case actions.POST_GALLERY_GALLERY_ITEMS + ERROR: {
      state = enableForm(state, "createGalleryGalleryItem");
      return setFormErrors(
        state,
        "createGalleryGalleryItem",
        action.payload.errors
      );
    }

    case actions.SET_IS_REMOVE_GALLERY_MODAL_VISIBLE: {
      return state.setIn(
        ["galleries", "isRemoveModalVisible"],
        action.payload.isVisible
      );
    }

    case actions.SET_IS_ADD_GALLERY_GALLERY_ITEM_MODAL_VISIBLE: {
      return state.setIn(
        ["forms", "createGalleryGalleryItem", "isAddModalVisible"],
        action.payload.isVisible
      );
    }

    case sectionsActions.GET_SECTION_GALLERIES + START: {
      return state.setIn(["galleries", "loading"], true);
    }
    case sectionsActions.GET_SECTION_GALLERIES + SUCCESS: {
      return state.setIn(["galleries", "loading"], false);
    }
    case sectionsActions.GET_SECTION_GALLERIES + ERROR: {
      return state.setIn(["galleries", "loading"], false);
    }

    case pagesTranslationsActions.GET_PAGES_TRANSLATION: {
      return state.setIn(["galleries", "loading"], true);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_SUCCESS: {
      let galleries = new Map();
      for (let locale in action.payload.entities.pageTranslations[
        action.payload.result
      ].pageTranslations) {
        for (let section in action.payload.entities.pageTranslations[
          action.payload.result
        ].pageTranslations[locale].sections) {
          for (let sectionItem in action.payload.entities.pageTranslations[
            action.payload.result
          ].pageTranslations[locale].sections[section].galleries) {
            let gallery =
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].galleries[
                sectionItem
              ];
            galleries = galleries.set(
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].galleries[
                sectionItem
              ].uid,
              fromJS(gallery)
            );
          }
        }
      }
      state = state.setIn(["galleries", "entities"], galleries);
      return state.setIn(["galleries", "loading"], false);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_ERROR: {
      return state.setIn(["galleries", "loading"], false);
    }

    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID + START: {
      return state.setIn(["galleries", "loading"], true);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID + SUCCESS: {
      let galleries = new Map();
      for (let locale in action.payload.entities.pageTranslations[
        action.payload.result
      ].pageTranslations) {
        for (let section in action.payload.entities.pageTranslations[
          action.payload.result
        ].pageTranslations[locale].sections) {
          for (let sectionItem in action.payload.entities.pageTranslations[
            action.payload.result
          ].pageTranslations[locale].sections[section].galleries) {
            let gallery =
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].galleries[
                sectionItem
              ];
            galleries = galleries.set(
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].galleries[
                sectionItem
              ].uid,
              fromJS(gallery)
            );
          }
        }
      }
      state = state.setIn(["galleries", "entities"], galleries);
      return state.setIn(["galleries", "loading"], false);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID + ERROR: {
      return state.setIn(["galleries", "loading"], false);
    }

    // case pagesListsActions.GET_PAGES_LIST_BY_SLUG+START: {
    //   return state.setIn(['galleries', 'loading'], true);
    //   }
    // case pagesListsActions.GET_PAGES_LIST_BY_SLUG+SUCCESS: {
    //   let fields = new Map();
    //   action.payload.entities.pagesLists[action.payload.result].pages.forEach(function(page, pageIndex){
    //     page.get('pageTranslations').map(function(pageTranslation, pageTranslationIndex){
    //       pageTranslation.get('sections').map(function(section, sectionIndex){
    //         // section.get('fields').map(function(field, fieldsIndex){
    //         //   if(field.get('fieldType')==='date'){
    //         //     field = field.set('value', moment(new Date(field.get('value'))).format('DD.MM.YYYY'));
    //         //   }
    //         //   fields = fields.set(field.get('uid'), field);
    //         // })
    //       })
    //     })
    //     // state = state.setIn(['fields','entities'],fields)
    //   })
    //   return state.setIn(['galleries', 'loading'], false);
    //   }
    // case pagesListsActions.GET_PAGES_LIST_BY_SLUG+ERROR: {
    //   return state.setIn(['galleries', 'loading'], false);
    //   }
  }

  return entitiesReducer(
    formsReducer(state, feature, action, Forms),
    feature,
    action
  );
}



// WEBPACK FOOTER //
// ./src/common/galleries/reducer.js